/** Original synthesized sound effects, without external samples. */
export class AudioBus {
  constructor() { this.enabled = true; this.context = null; }
  async unlock() {
    if (!this.enabled) return;
    try { this.context ||= new (window.AudioContext || window.webkitAudioContext)(); if (this.context.state === 'suspended') await this.context.resume(); }
    catch { /* Sound must not prevent play. */ }
  }
  play(event) {
    if (!this.enabled || !this.context || this.context.state !== 'running') return;
    const presets = { hit: [155,60,.11,'triangle'], ko: [320,40,.5,'sawtooth'], jump: [230,450,.08,'sine'], block: [700,250,.08,'sine'], recovery: [180,820,.23,'triangle'], go: [440,880,.3,'sine'], shieldbreak: [800,90,.35,'sawtooth'] };
    if (!presets[event.type]) return;
    const [start,end,duration,type] = presets[event.type];
    const oscillator = this.context.createOscillator(), gain = this.context.createGain(), now = this.context.currentTime;
    oscillator.type = type; oscillator.frequency.setValueAtTime(start,now); oscillator.frequency.exponentialRampToValueAtTime(end,now+duration);
    gain.gain.setValueAtTime(.0001,now); gain.gain.exponentialRampToValueAtTime(.07,now+.008); gain.gain.exponentialRampToValueAtTime(.0001,now+duration);
    oscillator.connect(gain).connect(this.context.destination); oscillator.start(now); oscillator.stop(now+duration+.02);
    oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
  }
  destroy() { this.context?.close(); }
}
